import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OnboardingService } from '../onboarding.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-signup-email-verification',
    templateUrl: './signup-email-verification.component.html',
    styleUrls: ['./signup-email-verification.component.scss']
})
export class SignUpVerificationURLComponent implements OnInit {
    emailVerified: any = false;
    signupVerified: any = false;
    @ViewChild('progressDialog', { static: true }) secondDialog: TemplateRef<any>;

    constructor(private onboardingService: OnboardingService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private dialog: MatDialog) { }

    ngOnInit(): void {
        const id = this.activatedRoute.snapshot.paramMap.get('id');
        console.log(id)
        this.dialog.open(this.secondDialog, { disableClose: true });
        this.onboardingService.verifyEmailOnURLToken(id).subscribe((res) => {
            console.log(res)
            this.signupVerified = false;
            if (!res.isOtpVerified) {
                this.dialog.closeAll()
                this.router.navigate(['/verification'])
            } else if (!res.isSetupVisited) {
                this.dialog.closeAll()
                this.router.navigate([`userProfiles/${res.id}/setup/1`])
            } else {
                this.dialog.closeAll()
                window.location.href = "/";
            }

            //   this.router.navigate(['/login'])
        }, err => {
            console.log(err)
            this.emailVerified = true;
            this.dialog.closeAll()
            setTimeout(() => {
                this.router.navigate(['/login'])
            })

        })
    }
}
